import React, { useEffect, useState } from 'react'
import {
  CAlert, CButton, CCard, CCardBody, CCol, CRow, CForm, CFormLabel, CFormSelect,
} from '@coreui/react'
import { api } from '../api/client'

interface EmpresaOption {
  empresaCodigo: string
  empresaNombre: string
}

interface ZonaOption {
  zonaCodigo: number
  zonaNombre: string
}

/**
 * Impresoras — réplica de activarimpresora.cs (SiprinMax GX).
 * UPDATE Zona SET ZonaImpresora=1. Mensajes literales del GX (incluido
 * el typo "No se econtro Ruta").
 */
const ImpresorasPage: React.FC = () => {
  const [empresas, setEmpresas] = useState<EmpresaOption[]>([])
  const [rutas, setRutas] = useState<ZonaOption[]>([])
  const [empresa, setEmpresa] = useState('')
  const [ruta, setRuta] = useState('')
  const [error, setError] = useState('')
  const [mensaje, setMensaje] = useState('')

  useEffect(() => {
    api.get<EmpresaOption[]>('/superadmin/empresas')
      .then((data) => {
        setEmpresas(data)
        if (data.length > 0) setEmpresa(data[0].empresaCodigo)
      })
      .catch((e: any) => setError(e.message))
  }, [])

  useEffect(() => {
    if (!empresa) return
    setRutas([])
    setRuta('')
    api.get<ZonaOption[]>(`/rutas?empresa=${encodeURIComponent(empresa)}`)
      .then((data) => {
        setRutas(data)
        if (data.length > 0) setRuta(String(data[0].zonaCodigo))
      })
      .catch((e: any) => setError(e.message))
  }, [empresa])

  const activar = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setMensaje('')
    try {
      const res = await api.post<{ message: string }>('/rutas/activar-impresora', {
        empresaCodigo: empresa,
        zonaCodigo: Number(ruta),
      })
      setMensaje(res.message)
    } catch (err: any) {
      setError(err.message)
    }
  }

  return (
    <>
      <CRow className="mb-4">
        <CCol>
          <h4>Impresoras</h4>
        </CCol>
      </CRow>

      {error && <CAlert color="danger" dismissible onClose={() => setError('')}>{error}</CAlert>}
      {mensaje && <CAlert color="success" dismissible onClose={() => setMensaje('')}>{mensaje}</CAlert>}

      <CCard className="mb-4">
        <CCardBody>
          <CForm onSubmit={activar}>
            <CRow className="g-3 align-items-end">
              <CCol md={6}>
                <CFormLabel>Empresa</CFormLabel>
                <CFormSelect value={empresa} onChange={(e) => setEmpresa(e.target.value)}>
                  {empresas.map((em) => (
                    <option key={em.empresaCodigo} value={em.empresaCodigo}>
                      {em.empresaCodigo} · {em.empresaNombre}
                    </option>
                  ))}
                </CFormSelect>
              </CCol>
              <CCol md={4}>
                <CFormLabel>Ruta</CFormLabel>
                <CFormSelect value={ruta} onChange={(e) => setRuta(e.target.value)}>
                  {rutas.map((z) => (
                    <option key={z.zonaCodigo} value={z.zonaCodigo}>
                      {z.zonaCodigo} · {z.zonaNombre}
                    </option>
                  ))}
                </CFormSelect>
              </CCol>
              <CCol md={2}>
                <CButton color="primary" type="submit" className="w-100">Activar</CButton>
              </CCol>
            </CRow>
          </CForm>
        </CCardBody>
      </CCard>
    </>
  )
}

export default ImpresorasPage
